/**
 * =================================================================
 * LE BANDEAU D'ENVIRONNEMENT : SUR LE POSTE DE DÉVELOPPEMENT SEULEMENT
 *
 * Du 22/09 au 29/10/2026, deux applications ServUp ont tourné en parallèle,
 * l'ancienne et servup4i, sans donnée ni compte en commun : un bandeau disait
 * en haut de chaque écran laquelle on avait sous les yeux. L'ancienne est
 * arrêtée depuis le 29/10 et son adresse renvoie vers app.servup4i.si : le
 * site n'a plus de bandeau (décision du 30/10/2026). Il ne reste que celui du
 * poste de développement, pour ne pas prendre le banc pour le site.
 *
 * La décision se prend sur le DOMAINE. `VITE_ENVIRONNEMENT=local` impose le
 * bandeau du banc ailleurs (prévisualisation, démonstration) ; toute autre
 * valeur est ignorée.
 * =================================================================
 */

export type CleEnvironnement = 'local';

export interface Environnement {
  cle: CleEnvironnement;
  libelle: string;
  couleur: string;
}

const BANC_LOCAL: Environnement = {
  cle: 'local',
  libelle: 'BANC LOCAL — poste de développement',
  couleur: '#4B5563'
};

/**
 * @param hote      `window.location.hostname`
 * @param surcharge valeur de `VITE_ENVIRONNEMENT` ; seule `local` compte
 * @returns le bandeau à afficher, ou `null` : aucun bandeau (le site)
 */
export function environnementDepuisHote(hote: string, surcharge?: string): Environnement | null {
  if (String(surcharge || '').trim().toLowerCase() === 'local') return BANC_LOCAL;

  const h = String(hote || '').trim().toLowerCase();
  if (h === 'localhost' || h === '127.0.0.1' || h === '::1' || h.endsWith('.local')) {
    return BANC_LOCAL;
  }
  return null;
}

/** L'environnement du navigateur courant (`null` : aucun bandeau). */
export function environnementCourant(): Environnement | null {
  const hote = typeof window !== 'undefined' ? window.location.hostname : '';
  const surcharge = import.meta.env?.VITE_ENVIRONNEMENT as string | undefined;
  return environnementDepuisHote(hote, surcharge);
}
